import { Box } from '@material-ui/core';
import { ArticleType } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { TypeDetailsForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/ArticleTypeDetailsForm';
import { CartItemDialogCommonFields } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/CartItemDialogCommonFields';
import { ArticleTypeMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ArticleTypeMap';
import { ItemMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ItemMap';
import { Icon } from '@/components/shared/components/Icon';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';

interface CartItemDialogFormProps {
  selectableArticleTypes: ArticleType[];
}

export const CartItemDialogForm = ({ selectableArticleTypes }: CartItemDialogFormProps) => {
  const { watch, setValue, clearErrors } = useFormContext();

  const currentItem = watch('item');
  const articleType = watch('item.type');

  const disableUnits = currentItem.type !== ArticleType.ONLINE_PRODUCT;

  useEffect(() => {
    setValue('item', ItemMap.changeArticleType(currentItem));
    clearErrors();
  }, [articleType]);

  return (
    <>
      <Box mb={3}>
        <SelectFormField
          name={'item.type'}
          label={'ARTICLE_TYPE'}
          selectOptions={selectableArticleTypes.map((type) => ({
            value: type,
            display: (
              <Box display={'flex'} alignItems={'center'}>
                <Icon size={20} style={{ marginBottom: 1 }}>
                  {ArticleTypeMap.toIcon(type)}
                </Icon>
                <Box style={{ marginLeft: '8px' }}>
                  <Text tId={type} />
                </Box>
              </Box>
            ),
          }))}
          fieldVariant={FieldVariant.form}
        />
      </Box>
      <Box mb={4}>
        <TypeDetailsForm articleType={currentItem.type} />
      </Box>
      <Box mb={8}>
        <CartItemDialogCommonFields disableUnits={disableUnits} />
      </Box>
    </>
  );
};
